import React, { useState } from "react";
import {
  Flex,
  IconButton,
  Avatar,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Badge,
  Text,
  useColorMode,
  useColorModeValue,
  Box,
} from "@chakra-ui/react";
import { FiBell, FiMoon, FiSun, FiLogOut, FiUser, FiMenu } from "react-icons/fi";
import { Link } from "react-router-dom";
import { useUser } from "../../context/UserContext";

const Navbar = ({ onOpen }) => {
  const { colorMode, toggleColorMode } = useColorMode();
  const { user, loading, logout } = useUser();

  // Dynamic colors for Navbar
  const navbarBg = useColorModeValue("#071251", "gray.800");
  const textColor = "white"; // Keep logo/nav icons white in both modes as per primary brand
  const menuListBg = useColorModeValue("white", "gray.700");
  const menuItemColor = useColorModeValue("gray.800", "white");

  const [notificationCount] = useState(0);

  const logoutHandler = () => {
    sessionStorage.removeItem("superAdminLawvs");
    logout();
  };

  return (
    <Flex
      position="fixed"
      top="0"
      left="0"
      right="0"
      h="64px"
      px={4}
      align="center"
      justify="space-between"
      bg={navbarBg}
      color={textColor}
      zIndex={1200}
      boxShadow="md"
    >
      {/* LEFT */}
      <Flex align="center" gap={3}>
        <IconButton
          // icon={<FiMenu />}
          display={{ base: "flex", md: "none" }}
          onClick={onOpen}
          variant="ghost"
          color="white"
          _hover={{ bg: "whiteAlpha.200" }}
          aria-label="Open Menu"
        />

        <Link to="/">
          <Text
            fontSize={{ base: "lg", md: "2xl" }}
            fontWeight="bold"
            color="white"
            letterSpacing="wider"
            marginY="auto"
          >
            JSK <span style={{ color: "#6366f1" }}>Book</span>
          </Text>
        </Link>
      </Flex>

      {/* RIGHT */}
      <Flex align="center" gap={{ base: 2, md: 4 }}>
        {/* User Balance */}
        {user?.wallet && (
          <Box display={{ base: "none", md: "flex" }} flexDirection="column" alignItems="center" textAlign="center" gap={1} mr={4}>
            <Box
              fontSize="10px"
              fontWeight="extrabold"
              color="whiteAlpha.600"
              letterSpacing="wider"
            >
              BALANCE
            </Box>
            <Box fontSize="lg" fontWeight="bold" color="white" mt="-1">
              {loading ? "..." : `₹${user?.wallet?.balance?.toLocaleString("en-IN") || 0}`}
            </Box>
          </Box>
        )}

        <IconButton
          icon={colorMode === "light" ? <FiMoon /> : <FiSun />}
          variant="ghost"
          color="white"
          onClick={toggleColorMode}
          _hover={{ bg: "whiteAlpha.200" }}
          aria-label="Toggle Theme"
        />

        {/* Notification */}
        <Box position="relative">
          <IconButton
            icon={<FiBell />}
            variant="ghost"
            color="white"
            _hover={{ bg: "whiteAlpha.200" }}
            aria-label="Notifications"
          />
          {notificationCount > 0 && (
            <Badge
              colorScheme="red"
              borderRadius="full"
              position="absolute"
              top="1"
              right="1"
              fontSize="0.5rem"
              px={1}
            >
              {notificationCount}
            </Badge>
          )}
        </Box>

        {/* Profile */}
        <Menu>
          <MenuButton>
            <Avatar size="sm" name="Admin" border="2px solid white" />
          </MenuButton>
          <MenuList bg={menuListBg} color={menuItemColor}>
            <MenuItem
              icon={<FiUser />}
              as={Link}
              to="/admin-profile"
              _hover={{ bg: useColorModeValue("gray.100", "gray.600") }}
            >
              My Profile
            </MenuItem>
            <MenuItem
              icon={<FiLogOut />}
              onClick={logoutHandler}
              _hover={{ bg: useColorModeValue("gray.100", "gray.600") }}
            >
              Logout
            </MenuItem>
          </MenuList>
        </Menu>
      </Flex>
    </Flex>
  );
};

export default Navbar;
